import { useNavigate, useRevalidator, useRouteLoaderData } from "react-router-dom";

import type { Assignment } from "./types";
import LocatingPreChecklist from "./requiredForms/locatingPreChecklist";
import LocatingPostChecklist from "./requiredForms/locatingPostChecklist";
import PotholingPreChecklist from "./requiredForms/potholingPreChecklist";
import PotholingPostChecklist from "./requiredForms/potholingPostChecklist";
import VehicleForm from "./requiredForms/vehicleForm";
import TrailerForm from "./requiredForms/trailerForm";

type AssignmentRequiredFormProps = {
    formKey: "PreChecklist" | "PostChecklist" | "PreVehicle" | "PostVehicle" | "PreTrailer" | "PostTrailer";
};

export default function AssignmentRequiredForm({ formKey }: AssignmentRequiredFormProps) {
    const assignment = useRouteLoaderData("assignment") as Assignment;
    const navigate = useNavigate();
    const revalidator = useRevalidator();
    const laborCategory = assignment.laborCategory || assignment.category || "";
    const userName = assignment.userName || assignment.leadName || assignment.supervisorName || "";
    const closeIt = () => {
        revalidator.revalidate();
        navigate("..");
    };

    switch (formKey) {
        case "PreChecklist":
            if (laborCategory === "Locating") {
                return (
                    <LocatingPreChecklist
                        formRequired
                        formName="locatingPreChecklist"
                        title="LOCATING PRE-CHECKLIST"
                        closeIt={closeIt}
                        requiredForms={assignment.requiredForms || "{}"}
                        assignmentId={assignment.id}
                        userName={userName}
                    />
                );
            }
            if (laborCategory === "Potholing") {
                return (
                    <PotholingPreChecklist
                        formRequired
                        formName="potholingPreChecklist"
                        title="POTHOLING PRE-CHECKLIST"
                        closeIt={closeIt}
                        requiredForms={assignment.requiredForms || "{}"}
                        assignmentId={assignment.id}
                        userName={userName}
                    />
                );
            }
            break;
        case "PostChecklist":
            if (laborCategory === "Locating") {
                return (
                    <LocatingPostChecklist
                        formRequired
                        formName="locatingPostChecklist"
                        title="LOCATING POST-CHECKLIST"
                        closeIt={closeIt}
                        requiredForms={assignment.requiredForms || "{}"}
                        assignmentId={assignment.id}
                        userName={userName}
                    />
                );
            }
            if (laborCategory === "Potholing") {
                return (
                    <PotholingPostChecklist
                        formRequired
                        formName="potholingPostChecklist"
                        title="POTHOLING POST-CHECKLIST"
                        closeIt={closeIt}
                        requiredForms={assignment.requiredForms || "{}"}
                        assignmentId={assignment.id}
                        userName={userName}
                    />
                );
            }
            break;
        case "PreVehicle":
            return (
                <VehicleForm
                    preOrPost="pre"
                    closeIt={closeIt}
                    assignmentId={assignment.id}
                    userName={userName}
                    isDriverDefault={assignment.isPreDriver}
                    vehicleId={assignment.preTruckId}
                    vehicleName={assignment.preTruckNumber}
                    vehicleDataStr={assignment.preVehicleData}
                />
            );
        case "PostVehicle":
            return (
                <VehicleForm
                    preOrPost="post"
                    closeIt={closeIt}
                    assignmentId={assignment.id}
                    userName={userName}
                    isDriverDefault={assignment.isPostDriver}
                    vehicleId={assignment.postVehicleId}
                    vehicleName={assignment.postTruckNumber}
                    vehicleDataStr={assignment.postVehicleData}
                />
            );
        case "PreTrailer":
            return (
                <TrailerForm
                    preOrPost ="pre"
                    closeIt = {closeIt}
                    assignmentId= {assignment.id}
                    userName = {userName}
                    hasTrailerDefault = {assignment.hasPreTrailer}
                    trailerStr = {assignment.preTrailerData}
                    trailerId = {assignment.preTrailerId}
                    trailerName = {assignment.preTrailerNumber}
                />
            );
        case "PostTrailer":
            return (
                <TrailerForm
                    preOrPost = "post"
                    closeIt = {closeIt}
                    assignmentId = {assignment.id}
                    userName = {userName}
                    hasTrailerDefault = {assignment.hasPostTrailer}
                    trailerStr = {assignment.postTrailerData}
                    trailerId = {assignment.postTrailerId}
                    trailerName = {assignment.postTrailerNumber}
                />
            );
    }

    return (
        <div className="p-3">
            <div className="alert alert-warning mb-3">
                This required form is not available for the assignment category.
            </div>
            <button type="button" className="btn btn-outline-secondary" onClick={() => navigate("..")}>
                Back
            </button>
        </div>
    );
}
